import { Container } from "./styles"
import { Reveal } from "../Reveal/Reveal";
import { useI18n } from "../../i18n/I18nProvider"
import { openCalendarPopup } from "../../utils/calendar"
import { trackEvent } from "../../utils/analytics"

export function Home() {
  const { t } = useI18n();

  return (
    <Container id="home">
      <div className="home-body">
        <div className="home-text">
          <div className="home-title">
            <h1>
              {t.home.title[0]} <span className="highlight">{t.home.title[1]}</span> {t.home.title[2]}
            </h1>
          </div>
          <Reveal animateIn="fadeInUp" delay={0.1 * 1000}>
            <h2 className="subhead">{t.home.subhead}</h2>
          </Reveal>
          <Reveal animateIn="fadeInUp" delay={0.2 * 1000}>
            <h3>{t.home.subtitle}</h3>
          </Reveal>

          <div className="bullet-list">
            {t.home.paragraphs.map((p, index) => (
              <Reveal
                key={index}
                animateIn="fadeInLeft"
                delay={(0.25 + index / 10) * 1000}
              >
                <p>{p}</p>
              </Reveal>
            ))}
          </div>

          <Reveal
            animateIn="fadeInLeft"
            delay={(0.45) * 1000}
            style={{ marginTop: "2rem", marginBottom: "2rem" }}
          >
            <p className="center highlight">
              {t.home.footerText}
            </p>
          </Reveal>

        </div>
        <div className="home-image">
          <Reveal animateIn="fadeInRight" delay={0.25 * 1000}>
            <figure className="image-figure">
              <img
                src="/images/hero-image-700.webp"
                srcSet="/images/hero-image-250.webp 250w, /images/hero-image-500.webp 500w, /images/hero-image-700.webp 700w, /images/hero-image-1000.webp 1000w"
                sizes="(max-width: 600px) 250px, (max-width: 1024px) 320px, 430px"
                alt="Angelo Falci"
                width={700}
                height={700}
                loading="eager"
                // @ts-expect-error fetchPriority is not yet in React 17's DOM typings
                fetchPriority="high"
              />
              <figcaption className="center">
                <em>{t.home.caption}</em>
              </figcaption>
            </figure>
          </Reveal>
        </div>
      </div>

      <div className="home-actions">
        <button
          className="button"
          onClick={() => {
            openCalendarPopup(t.contacts.calendarLink);
            void trackEvent('home_cta_click', { label: 'speak_goals' });
          }}
        >
          {t.home.ctas.speakGoals}
        </button>
        <button
          className="button button-secondary"
          onClick={() => {
            document.getElementById('prices')?.scrollIntoView({ behavior: 'smooth' });
            void trackEvent('home_cta_click', { label: 'look_plans' });
          }}
        >
          {t.home.ctas.lookPlans}
        </button>
      </div>
    </Container>
  )
}
